import React, { createContext, useContext, ReactNode } from 'react';

export type Environment = 'dev' | 'test' | 'stage' | 'prod';

interface EnvironmentContextType {
  environment: Environment;
  /** No-op after env-per-deployment refactor — environment is fixed at deploy time. */
  setEnvironment: (env: Environment) => void;
  environments: Environment[];
}

// Environment is baked in at build time via VITE_ENVIRONMENT.
// For local development set VITE_ENVIRONMENT in client/.env.
const DEPLOYMENT_ENV = (
  import.meta.env.VITE_ENVIRONMENT ?? 'prod'
) as Environment;

export const EnvironmentContext = createContext<EnvironmentContextType | undefined>(undefined);

export function EnvironmentProvider({ children }: { children: ReactNode }) {
  return (
    <EnvironmentContext.Provider
      value={{
        environment: DEPLOYMENT_ENV,
        setEnvironment: () => { /* no-op — env is deployment-time, not runtime */ },
        environments: [DEPLOYMENT_ENV],
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
}

export function useEnvironment() {
  const context = useContext(EnvironmentContext);
  if (context === undefined) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider');
  }
  return context;
}
